import { Box, Button, Tooltip } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useEditor } from 'widgets/sdk';

const FilterOptions = () => {
  const { openWidgetSideMenu, closeWidgetSideMenu, isSideWidgetMenuOpen } = useEditor();
  const { t } = useTranslation('editor_widget_toolbar', { keyPrefix: 'imageToolbar', useSuspense: false });

  const handleClick = () => {
    if (isSideWidgetMenuOpen) return closeWidgetSideMenu();
    openWidgetSideMenu();
  };

  return (
    <Box data-testid='edit-image-option'>
      <Tooltip hasArrow label={t('settingsSideBar.imageFilters')}>
        <Button
          size='sm'
          onClick={handleClick}
          fontWeight='semibold'
          variant='ghost-with-active'
          data-testid='img_toolbar-edit_image'
          textTransform={'capitalize'}
          isActive={isSideWidgetMenuOpen}
        >
          {t('toolbar.filterLabel')}
        </Button>
      </Tooltip>
    </Box>
  );
};

export default FilterOptions;
